function isEmpty(value: string): value is "" | null | undefined;
function isEmpty(value: Array<unknown>): value is [] | null | undefined;
function isEmpty(value: Date): value is never;
function isEmpty(
  value: object,
): value is Record<string, never> | null | undefined;

function isEmpty(
  value: object | string | unknown,
): value is undefined | null | Record<string, never> | "" {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" &&
      !(value instanceof Date) &&
      Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
}

export default isEmpty;
